"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notificationElement = document.createElement("div");
    notificationElement.classList.add("notification", type);
    notificationElement.style.top = "".concat(posTop, "px");
    notificationElement.style.right = "".concat(posRight, "px");
    var titleElement = document.createElement("h2");
    titleElement.innerText = title;
    titleElement.classList.add("title");
    var descriptionElement = document.createElement("p");
    descriptionElement.innerText = description;
    notificationElement.append(titleElement, descriptionElement);
    document.body.append(notificationElement);
    setTimeout(function() {
        notificationElement.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.9ca7951d.js.map
